import { useResponsive } from '@/hooks/use-responsive';
import { GetExetelAppMobile } from './get-exetel-app-mobile';
import { GetExetelAppDesktop } from './get-exetel-app-desktop';
import { CMSSeo } from '../cms-seo';

const GetExetelApp = () => {
  const { isDesktop } = useResponsive();

  return (
    <>
      <CMSSeo />
      {isDesktop ? <GetExetelAppDesktop /> : <GetExetelAppMobile />}
    </>
  );
};

export { GetExetelApp };
